import React from "react";
import { useRouteError, Link } from "react-router-dom";
import logoTavad from '../img/logo-tavad-color.svg'; // Asegúrate de que la ruta sea correcta

const ErrorPage = () => {
  const error = useRouteError();
  console.error(error); // Para depuración

  return (
    <div className="error-container has-background-light">
      <div className="error-content">
        <h1 className="is-size-1 has-text-link has-text-weight-bold">
          {error.status || "Error"}
        </h1>
        <h2 className="is-size-3">
          {error.status === 404 ? "Página no encontrada" : "Ocurrió un error"}
        </h2>
        <p className="error-message">
          {error.status === 404
            ? "Lo sentimos, la página que buscas no existe."
            : "Lo sentimos, ocurrió un problema al cargar la página."}
        </p>

        {process.env.NODE_ENV === "development" && error && (
          <div className="mb-5">
            <p>
              <strong>Detalles del Error:</strong>
            </p>
            <p>{error.statusText || error.message}</p>
          </div>
        )}

        <div className="button-group">
          <Link to="/" className="button is-link is-outlined">
            <span>Volver a la página inicial</span>
          </Link>
          <button className="button is-link" onClick={() => window.history.back()}>
            <span>Volver atrás</span>
          </button>
        </div>
      </div>
      <img src={logoTavad} alt="Logo Tavad" className="error-logo" />
    </div>
  );
};

export default ErrorPage;
